import {Component, computed, input} from "@angular/core";
import type {LanguageCode} from "../../models/i18n/Language";

@Component({
  selector: "rf-flag-icon",
  templateUrl: "./flag-icon.html",
  styleUrl: "./flag-icon.scss",
  imports: [],
})
export class FlagIcon {
  public readonly languageCode = input.required<LanguageCode>();
  public readonly languageName = input<string>();

  protected readonly codeClassName = computed(() => `flag-icon-${this.languageCode()}`);
}
